var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSettingsMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 11.5V12V12.5L20.9 14.6L18.7 18.4L15.6 17.3L14.7 17.8L14.2 21H9.8L9.2 17.8C8.9 17.7 8.6 17.5 8.3 17.3L5.2 18.4L3 14.6L5.5 12.5V12V11.5L3 9.4L5.2 5.6L8.3 6.7C8.3 6.7 8.9 6.3 9.2 6.2L9.8 3H14.2L14.8 6.2L15.7 6.7L18.8 5.6L21 9.4L18.5 11.5Z",
    stroke: "#111827",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2.5,
    fill: "none",
    stroke: "#111827",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettingsMenu);
export default __webpack_public_path__ + "static/media/icon-settings-menu.79cbbdea885a2bef7cc95caa1cb15c33.svg";
export { ForwardRef as ReactComponent };